import React from 'react';

export default function IcBarCode() {
  return (
    <svg width="100%" height="100%" version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      viewBox="0 0 548.8 504" >
      <path d="M0,0h44.8v504H0L0,0z" />
      <path d="M78.4,0h44.8v504H78.4V0z" />
      <path d="M140,0h44.8v504H140V0z" />
      <path d="M218.4,0h22.4v504h-22.4V0z" />
      <path d="M274.4,0h22.4v504h-22.4V0z" />
      <path d="M330.4,0H392v504h-61.6V0z" />
      <path d="M442.4,0h56v504h-56V0z" />
      <path d="M526.4,0h22.4v504h-22.4V0z" />
    </svg>


  );
}
